export enum AuthState {
    UNAUTHENTICATED = 'unauthenticated',
    LOGGED_OUT = 'logged-out',
    TIMEOUT = 'timeout',
    ERROR = 'error',
}
